// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1TumQ","quickLinks":"styles_quickLinks__3PMhT","mainContent":"styles_mainContent__35s6u"};